/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o índice e a
 * camada do mapa.
 */
import { createElement, useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { SmokeLayerManager } from './layer';
import { SmokePopup } from './SmokePopup';
import { iniciarSyncFumaca, registrarNovaTentativa } from './sync';

export { refreshFumaca } from './sync';

export function useSmokeLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => iniciarSyncFumaca(), []);

  useEffect(() => {
    if (!map) return;
    const manager = new SmokeLayerManager(map, (area) => createElement(SmokePopup, { area }));
    registrarNovaTentativa(() => manager.tentarDeNovo());
    return () => {
      registrarNovaTentativa(null);
      manager.dispose();
    };
  }, [map]);
}
